import React, { useEffect } from "react";
import logo from "./img/enjuggernaut_logo.png";
import small_logo from "./img/enjuggernaut_logo_small.png";
import { MenuBar } from "./MenuBar";

type SidebarProps = {
  minimized: boolean;
  drawer: boolean;
};

export const Sidebar: React.FC<SidebarProps> = ({ minimized, drawer }) => {
  return (
    <div
      className={`right-0 ${drawer ? "" : "hidden lg:block"} min-h-screen ${
        minimized ? "bg-[#1E1E1E]" : "dark-panel fixed w-1/4 lg:w-1/5 xl:w-1/6"
      }`}
    >
      {minimized && (
        <img src={small_logo} className="mx-auto scale-75 pt-4" alt="logo" />
      )}

      {!minimized && (
        <img src={logo} className="mx-auto w-4/5 pt-4" alt="logo" />
      )}

      <MenuBar centered={false} minimized={minimized} />
    </div>
  );
};
